import { render } from "./supportWidget.vue?vue&type=template&id=defab674"
import script from "./supportWidget.vue?vue&type=script&lang=js"
export * from "./supportWidget.vue?vue&type=script&lang=js"

import "./supportWidget.vue?vue&type=style&index=0&id=defab674&lang=css"
script.render = render

export default script